import type { FaireReviewEntity } from "../../entity_types/review";

// Real product review, pulled from Sweet Wink's live Faire product page for
// the Gingham Printed Tulle Tiered Tutu (faire.com/product/p_s46e7wm4wv), via
// the authenticated PDP reviews API (verbatim reviewer name/location/text/date
// — nothing paraphrased or invented).
export const review_sw5: FaireReviewEntity = {
  token: "review_sw5",
  type: "review",
  brandName: "Sweet Wink",
  brandToken: "b_gro99lye",
  productToken: "p_s46e7wm4wv",
  productImageUrl:
    "https://cdn.faire.com/fastly/884bc0552955c73972fd48a893695a166f8c5959314fbddb5b344a74ac1ac5dd.jpeg",
  reviewerName: "Hannah D.",
  reviewerLocation: "Saint Amant, LA",
  stars: 5,
  reviewText:
    "The Gingham Printed Tulle Tiered Tutu is beautifully made with great attention to detail. The layers of tulle give it a fun, whimsical look while still feeling soft and comfortable. This will be a lovely piece for our shop.",
  reviewDate: "Mar 13, 2026",
  reviewType: "product",
  meta: {
    source: "api",
    importedAt: "2026-08-11T21:28:00.000Z",
    importedBy: "entity-db-cli",
  },
};
